import type { QueryHookOptions, TypedDocumentNode } from '@apollo/client';
import { gql, useQuery } from '@apollo/client';
import type { Query, QueryDevelopmentStatusWithFilterArgs } from '@/types/GraphqlSchema';

type DevelopmentStatusWithFilterQueryData = Pick<Query, 'developmentStatusWithFilter'>;

const DEVELOPMENT_STATUS_WITH_FILTER_QUERY: TypedDocumentNode<
  DevelopmentStatusWithFilterQueryData,
  QueryDevelopmentStatusWithFilterArgs
> = gql`
  query developmentStatusWithFilter($countries: [String!]) {
    developmentStatusWithFilter(countries: $countries) {
      id
      name
      isDisabled
    }
  }
`;

type DevelopmentStatusWithFilterQueryOptions = QueryHookOptions<
  DevelopmentStatusWithFilterQueryData,
  QueryDevelopmentStatusWithFilterArgs
>;

export const useDevelopmentStatus = (
  countries: string[] = [],
  options?: DevelopmentStatusWithFilterQueryOptions,
) => {
  const queryOptions: DevelopmentStatusWithFilterQueryOptions = {
    fetchPolicy: 'cache-and-network',
    variables: {
      countries,
    },
    errorPolicy: 'all',
    ...(options ?? {}),
  };

  const { data, loading, error, refetch } = useQuery(
    DEVELOPMENT_STATUS_WITH_FILTER_QUERY,
    queryOptions,
  );

  return {
    data,
    loading,
    error,
    refetch,
    developmentStatuses: data?.developmentStatusWithFilter ?? [],
  };
};
